import { Grid } from '@mui/material';
import { Outlet } from 'react-router';

const styles = {
  fullHeight: {
    height: '100vh'
  },
  fullWidth: {
    width: '100vw'
  }
};

const CenteredComponent = () => {
  return (
    <Grid
      container
      sx={styles.fullHeight}
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid>
        <Grid container sx={styles.fullWidth} justifyContent="center">
          <Grid>
            <Outlet />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CenteredComponent;
